import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EvsProductService } from "../../../../common/services/EvsProduct.service";
import { IOption } from "ng-select";
import { BatchService } from "../batchstamp/batch.service";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { AuthBusinessService } from "../../../../common/services/AuthBusiness.service";
import { UploadService } from '../../../../common/services/Upload.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: "active-stamp-modal-content",
  templateUrl: "./modalActivePrintBatch.template.html",
  styles: [
    "/deep/ bs-datepicker-container{z-index: 1700 !important;} .warning{margin-top:10px;}",
  ],
  providers: [EvsProductService, AuthBusinessService],
})
export class ModalActivePrintBatchComponent implements OnInit {
  batch_detail: any;
  closeBtnName: string;

  public message: any = { class: "", content: "" };
  public FormActiveStamp: FormGroup;
  is_loading = false;
  list_product: Array<IOption> = [];

  has_product: boolean = false;
  isManufacturer = "1";

  active_child: boolean = false;
  has_child: boolean = false;
  active_left: number;
  public user: any;
  public no_exist_on_seller: boolean = false;
  public choice_product: any;
  public is_override_warranty: boolean = false;
  public cachedReminderConfig: any = null;

  public nameAction: any;
  public note: any;
  public listImageDistribution: any[] = [];

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private batchService: BatchService,
    private productService: EvsProductService,
    private connectService: AuthBusinessService,
    private toastr: ToastrService,
    private upload: UploadService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.initBatchData();
  }

  deleteImage(index: number) {
    this.listImageDistribution.splice(index, 1);
  }

  tusUploadReturnBoxImages = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      if (result) {
        for (const image of item.target.files) {
          const fileData = new FormData();
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
                name: res.data.fileName || image.name,
                type: image.type,
              };
              if (this.listImageDistribution.length >= 5) {
                this.toastr.warning(
                  this.translate.instant('SO_LUONG_ANH_TOI_DA_LA_5'),
                  this.translate.instant('CANH_BAO')
                );
              } else {
                this.listImageDistribution.push(image2);
              }
            } else {
              this.toastr.error('Tải ảnh không thành công', 'Lỗi');
            }
          });
        }
      } else {
        this.toastr.error('Không đúng định dạng ảnh', 'Lỗi');
      }
    });
  }   

  initBatchData() {
    if (this.batch_detail.has_child) {
      this.has_child = true;
      this.active_child = true;
    }
    this.active_left =
      this.batch_detail.active_left != null
        ? this.batch_detail.active_left
        : this.batch_detail.quantity;
    $("#produce_time").datepicker({
      format: "dd/mm/yyyy",
      // "setDate": new Date(),
    });
    // $('#product_id').select2({ placeholder: "-- Chọn sản phẩm --", allowClear: false });
    this.getListProduct();
    this.createForm();
  }

  getListProduct() {
    this.productService
      .listProduct({ status: 1, limit: 2000 })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let list = [];
          for (let _data of res.data.products) {
            list.push({
              value: _data.id,
              label: _data.name,
              barcode: _data.sku,
            });
          }
          this.list_product = list;
        } else {
          console.log("listProduct:error", res);
        }
      })
      .catch((err: any) => {
        console.log("listProduct:catch", err);
      });
  }

  choiceProduct($event) {
    this.choice_product = $event;
  }

  setBuyOnline($event) {
    if (
      this.FormActiveStamp.get("active_buy_online").value &&
      this.user.seller_id
    ) {
      let barcode = this.choice_product.barcode;
      if (barcode) {
        this.connectService
          .checkBuyOnSeller(this.user.seller_id, barcode)
          .subscribe((res) => {
            this.no_exist_on_seller = !res.data ? true : false;
          });
      }
    } else {
      this.no_exist_on_seller = false;
    }
  }

  createForm() {
    this.FormActiveStamp = this.fb.group({
      product_id: [null],
      produce_time: [null],
      guarantee_days: [null],
      guarantee_days_max: [null],
      guarantee_days_update: [null],
      guarantee_days_max_update: [null],
      // is_manufacturer: [null],
      type_guarantee_day: ["months"],
      type_guarantee_day_max: ["months"],
      count_child: [null],
      name_child: [null],
      active_buy_online: [null],
      is_override_reminder: [false],
      is_maintenance_reminder: [false],
      maintenance_mode: ["once"],
      maintenance_cycle: [null],
      maintenance_cycle_unit: ["months"],
      is_extend_maintenance: [false],
      extend_limit: [null],
      is_expired_reminder: [false],
      expired_mode: ["once"],
      expired_cycle: [null],
      expired_cycle_unit: ["days"],
    });
  }

  productId: any = null;

  parseReminderConfig(rawConfig: any) {
    if (!rawConfig) return null;
    let config = rawConfig.data ? rawConfig.data : rawConfig;
    
    let is_maintenance_reminder = config.is_maintenance_reminder || false;
    let maintenance_mode = config.maintenance_mode || 'once';
    let maintenance_cycle = config.maintenance_cycle || null;
    let maintenance_cycle_unit = config.maintenance_cycle_unit || 'months';
    let is_extend_maintenance = config.is_extend_maintenance || false;
    let extend_limit = config.extend_limit || null;

    if (config.reminderMaintain) {
      is_maintenance_reminder = config.reminderMaintain.isSelect || false;
      maintenance_mode = (config.reminderMaintain.mode === 'REPEAT' || config.reminderMaintain.mode === 'recurring') ? 'recurring' : 'once';
      maintenance_cycle = config.reminderMaintain.numberTimeNotify || null;
      const tType = config.reminderMaintain.timeType;
      maintenance_cycle_unit = tType === 'DAY' ? 'days' : (tType === 'YEAR' ? 'years' : 'months');
      is_extend_maintenance = config.reminderMaintain.reminderContinue || false;
      extend_limit = config.reminderMaintain.numberOfLimit || null;
    }

    let is_expired_reminder = config.is_expired_reminder || false;
    let expired_mode = config.expired_mode || 'once';
    let expired_cycle = config.expired_cycle || null;
    let expired_cycle_unit = config.expired_cycle_unit || 'months';

    if (config.reminderExpired) {
      is_expired_reminder = config.reminderExpired.isSelect || false;
      expired_mode = (config.reminderExpired.mode === 'REPEAT' || config.reminderExpired.mode === 'recurring') ? 'recurring' : 'once';
      expired_cycle = config.reminderExpired.numberTimeNotify || null;
      const tType = config.reminderExpired.timeType;
      expired_cycle_unit = tType === 'DAY' ? 'days' : (tType === 'YEAR' ? 'years' : 'months');
    }

    return {
      is_maintenance_reminder,
      is_extend_maintenance,
      maintenance_mode,
      maintenance_cycle,
      maintenance_cycle_unit,
      extend_limit,
      is_expired_reminder,
      expired_mode,
      expired_cycle,
      expired_cycle_unit
    };
  }

  fillReminderConfig() {
    if (!this.cachedReminderConfig) return;
    const parsed = this.parseReminderConfig(this.cachedReminderConfig);
    if (parsed) {
      this.FormActiveStamp.patchValue(parsed);
    }
  }

  clearReminderConfig() {
    this.FormActiveStamp.patchValue({
      is_maintenance_reminder: false,
      is_extend_maintenance: false,
      maintenance_mode: 'once',
      maintenance_cycle: null,
      maintenance_cycle_unit: 'months',
      extend_limit: null,
      is_expired_reminder: false,
      expired_mode: 'once',
      expired_cycle: null,
      expired_cycle_unit: 'months',
    });
  }

  onOverrideChange(isOverride: boolean) {
    this.is_override_warranty = isOverride;
    if (isOverride) {
      if (this.cachedReminderConfig) {
        this.fillReminderConfig();
      } else if (this.productId) {
        this.fetchAndFillReminderConfig();
      }
    } else {
      this.clearReminderConfig();
    }
  }

  fetchAndFillReminderConfig() {
    if (!this.productId) return;
    this.productService.getProductWarrantyReminderConfig(this.productId).subscribe(
      (res: any) => {
        if (res && (res.data || res.isSelect !== undefined || res.is_maintenance_reminder !== undefined || res.reminderMaintain)) {
          this.cachedReminderConfig = res.data ? res.data : res;
        } else {
          this.cachedReminderConfig = null;
        }
        if (this.is_override_warranty) {
          this.fillReminderConfig();
        }
      },
      () => {
        // Fallback to getDetaiById if endpoint fails
        this.productService.getDetaiById(this.productId).subscribe((res: any) => {
          if (res && !res.error && res.data) {
            this.cachedReminderConfig = res.data;
            if (this.is_override_warranty) {
              this.fillReminderConfig();
            }
          }
        });
      }
    );
  }

  changeProduct(event) {
    this.productId = event ? event : null;
    if (this.productId) {
      this.fetchAndFillReminderConfig();
    } else {
      this.cachedReminderConfig = null;
      this.is_override_warranty = false;
      this.clearReminderConfig();
    }
  }

  submitActiveStamp(data) {
    this.is_loading = true;

    if (data.is_extend_maintenance) {
      if (!data.extend_limit || parseInt(data.extend_limit) <= 0) {
        this.toastr.warning('Vui lòng nhập giới hạn số lần gửi sau khi hết hạn BH lớn hơn 0', 'Cảnh báo:', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        this.is_loading = false;
        return;
      }
    }

    let request: any = {};
    if (this.productId) {
      request.product_id = this.productId;
    }

    request.active_buy_online = data.active_buy_online || false;

    if (this.nameAction) {
      request.name = this.nameAction;
    }
    if (this.note) {
      request.note = this.note;
    }
    if (this.listImageDistribution && this.listImageDistribution.length > 0) {
      request.document = {
        items: this.listImageDistribution
      };
    }
    // else {
    //   request.is_manufacturer = data.is_manufacturer.length ? data.is_manufacturer : "1";
    // }

    if (data.produce_time) {
      request.produce_time = moment(data.produce_time).format("YYYY-MM-DD");
    }
    if (
      data.guarantee_days_update &&
      parseInt(data.guarantee_days_update) >= 0
    ) {
      request.guarantee_days_update = data.guarantee_days_update;
      // if (data.type_guarantee_day == "d") {
      //   request.guarantee_days = data.guarantee_days;
      // } else if (data.type_guarantee_day == "y") {
      //   request.guarantee_days = parseInt(data.guarantee_days) * 365;
      // } else {
      //   request.guarantee_days = parseInt(data.guarantee_days) * 31;
      // }
    } else {
      request.guarantee_days_update = null;
    }
    if (
      data.guarantee_days_max_update &&
      parseInt(data.guarantee_days_max_update) >= 0
    ) {
      request.guarantee_days_max_update = data.guarantee_days_max_update;
      // if (data.type_guarantee_day_max == "days") {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max);
      // } else if (data.type_guarantee_day_max == "years") {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 365;
      // } else {
      //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 31;
      // }
    } else {
      request.guarantee_days_max_update = null;
    }

    if (data.count_child) {
      request.count_child = data.count_child;
    } else if (this.batch_detail.has_child) {
      // nếu ko nhập count_child mà trong khi lô đã từng tách thì ntn
      request.count_child = this.batch_detail.active_left;
    }
    if (data.name_child) {
      request.name_child = data.name_child;
    }

    //gan kieu d/m/y cua thoi gian bao hanh vao truong request
    request.type_guarantee_day = data.type_guarantee_day;
    request.type_guarantee_day_max = data.type_guarantee_day_max;
    // if (data.type_guarantee_day) {
    //   request.type_guarantee_day = data.type_guarantee_day;
    // }
    // if (data.type_guarantee_day_max) {
    //   request.type_guarantee_day_max = data.type_guarantee_day_max;
    // } //end gan kieu d/m/y

    if (this.batch_detail.is_baohanh && this.is_override_warranty) {
      request.is_override = true;
      request.warranty_reminder_config = {};
      
      if (data.is_maintenance_reminder) {
        request.warranty_reminder_config.reminderMaintain = {
          isSelect: true,
          mode: data.maintenance_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: data.is_extend_maintenance || false,
          numberTimeNotify: parseInt(data.maintenance_cycle) || 0,
          timeType: data.maintenance_cycle_unit === 'days' ? 'DAY' : (data.maintenance_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: data.extend_limit ? parseInt(data.extend_limit) : 0
        };
      } else {
        request.warranty_reminder_config.reminderMaintain = {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: 0
        };
      }

      if (data.is_expired_reminder) {
        request.warranty_reminder_config.reminderExpired = {
          isSelect: true,
          mode: data.expired_mode === 'once' ? 'ONCE' : 'REPEAT',
          reminderContinue: false,
          numberTimeNotify: parseInt(data.expired_cycle) || 0,
          timeType: data.expired_cycle_unit === 'days' ? 'DAY' : (data.expired_cycle_unit === 'months' ? 'MONTH' : 'YEAR'),
          numberOfLimit: 1
        };
      } else {
        request.warranty_reminder_config.reminderExpired = {
          isSelect: false,
          mode: 'ONCE',
          reminderContinue: false,
          numberTimeNotify: 0,
          timeType: 'DAY',
          numberOfLimit: 0
        };
      }
    }

    // console.log(request);
    // return;
    this.batchService
      .activeForPrint(this.batch_detail.id, request)
      .toPromise()
      .then((res: any) => {
        this.is_loading = false;
        if (res.code == 1) {
          this.createForm();
          let mess: any;
          if (
            !request.count_child ||
            this.active_left - request.count_child == 0
          ) {
            this.bsModalRef.hide();
            mess = res.message ? res.message : "Kích hoạt lô thành công.";
          } else {
            this.active_left = this.active_left - request.count_child;
            mess = res.message
              ? res.message
              : "Tạo và kích hoạt lô cấp 2 thành công.";
          }

          this.toastr.success("Kích hoạt thành công.", "Thành công:", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
        } else {
          console.log("error:false", res.message);
          let mess = res.message
            ? res.message
            : "Thao tác không thành công. Vui lòng thử lại!";
          this.toastr.warning(mess, "Cảnh báo:", {
            timeOut: 4000,
            positionClass: "toast-top-right",
          });
        }
      })
      .catch((err: any) => {
        this.is_loading = false;
        console.log("catch:", err);
        let mess = err.message
          ? err.message
          : "Thao tác thành công. Vui lòng thử lại!";
        this.toastr.warning(mess, "Cảnh báo:", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
      });
  }

  preventNonPositiveNumber(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    // Cho phép: phím số (0–9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return;
    }
    const target = event.target as HTMLInputElement;
    // Ngăn nhập số 0 ở đầu tiên
    if ((target.selectionStart === 0 && target.selectionEnd === target.value.length && charCode === 48) || 
        (target.value === '' && charCode === 48)) {
      event.preventDefault();
    }
  }

  onPastePositiveNumber(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^[1-9][0-9]*$/.test(pastedText)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/modalActivePrintBatch.component.ts